export default __webpack_public_path__ + "static/media/cat.9aec7eb6.png";